import React, { useEffect, useState } from "react";
const DataSummary = ({ data, fy }) => {
  const [summaryOfData, setSummaryOfData] = useState(null);

  function summarizeNestedData(data) {
    const summary = {
      assetGroup: {},
      mainCause: {},
      subCause: {},
      month: {},
      shift: {},
      upDown: {},
      sectionName: {},
    };

    data.forEach((yearItem) => {
      yearItem.children.forEach((assetGroupItem) => {
        const assetGroup = assetGroupItem.ASSET_GROUP;
        assetGroupItem.children.forEach((mainCauseItem) => {
          const mainCause = mainCauseItem.MAIN_CAUSE_DESC;
          mainCauseItem.children.forEach((subCauseItem) => {
            const subCause = subCauseItem.SUB_CAUSE_DESC;
            subCauseItem.children.forEach((monthItem) => {
              const month = monthItem.A_MONTH;
              const dataArray = monthItem.data;
              const count = dataArray.length;

              // Sum to Asset Group
              summary.assetGroup[assetGroup] =
                (summary.assetGroup[assetGroup] || 0) + count;

              // Sum to Main Cause
              summary.mainCause[mainCause] =
                (summary.mainCause[mainCause] || 0) + count;

              // Sum to Sub Cause
              summary.subCause[subCause] =
                (summary.subCause[subCause] || 0) + count;

              // Sum to Month
              summary.month[month] = (summary.month[month] || 0) + count;

              // Go inside each data item
              dataArray.forEach((item) => {
                const shift = item.SHIFT;
                const upDown = item.UP_DOWN;
                const sectionName = item.SECTION_NAME;

                summary.shift[shift] = (summary.shift[shift] || 0) + 1;
                summary.upDown[upDown] = (summary.upDown[upDown] || 0) + 1;
                summary.sectionName[sectionName] =
                  (summary.sectionName[sectionName] || 0) + 1;
              });
            });
          });
        });
      });
    });

    const sortedSummary = {};

    Object.keys(summary).forEach((category) => {
      const entries = Object.entries(summary[category]);

      // Sort by value descending
      entries.sort((a, b) => b[1] - a[1]);

      // Convert back to object
      sortedSummary[category] = Object.fromEntries(entries);
    });

    setSummaryOfData(sortedSummary);
  }
  useEffect(() => {
    if (data) {
      let tempData = data?.filter((obj) => obj.F_YEAR == fy);
      summarizeNestedData(tempData);
    }
  }, [fy, data]);

  const renderTable = (dataObj) => {
    let total =
      Object.keys(dataObj).length > 1
        ? Object?.values(dataObj)?.reduce(
            (sum, value) => sum + Number(value) || 0
          )
        : 0;

    return (
      <table
        className="table newUiTable table-hover table-striped"
        style={{ fontSize: "11px" }}
      >
        <thead className="m-0 p-0">
          <tr>
            <th>Sn</th>
            <th>Head</th>
            <th>causes</th>
            <th>%</th>
          </tr>
        </thead>
        <tbody className="m-0 p-0">
          {Object.entries(dataObj).map(([key, value], index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{key.replace("_", "-")}</td>
                <td>{value}</td>
                <td>{((Number(value) / total) * 100).toFixed(1)}%</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };
  return (
    <div>
      <h6 className="bg-dark text-white p-1">Asset failure summary</h6>
      {summaryOfData && (
        <div className="mt-0 pt-0">
          <b style={{ fontSize: "12x" }} className=" ">
            Asset group
          </b>
          <hr className="m-0 p-0" />
          {renderTable(summaryOfData.assetGroup)}
        </div>
      )}
      {summaryOfData && (
        <div className="mt-0 pt-0">
          <b style={{ fontSize: "12x" }} className=" ">
            Shift wise
          </b>
          <hr className="m-0 p-0" />
          {renderTable(summaryOfData.shift)}
        </div>
      )}{" "}
      {summaryOfData && (
        <div className="mt-0 pt-0">
          <b style={{ fontSize: "12x" }} className=" ">
            Direction wise
          </b>
          <hr className="m-0 p-0" />
          {renderTable(summaryOfData.upDown)}
        </div>
      )}
    </div>
  );
};
export default DataSummary;
